module.exports = "/_next/static/images/harajuku_takeout-6b5f85e45e3c288a813495f11994b476.jpg";